import styled from 'styled-components'
import { Button as btn } from 'antd'
import { PeopleEdit } from '@styled-icons/fluentui-system-regular/PeopleEdit'
import { DeleteDismiss } from '@styled-icons/fluentui-system-regular/DeleteDismiss'
import { ArrowDown as AD } from '@styled-icons/bootstrap/ArrowDown'
import { ArrowUp as AU } from '@styled-icons/bootstrap/ArrowUp'
import { ArrowSort as AS } from '@styled-icons/fluentui-system-filled/ArrowSort'

export const Container = styled.div`
  display: flex;
  height: 100%;
`
export const Section = styled.div`
  flex: 1;
  padding: var(--bq-spacing-m) 0px;
`

export const RoleListWrapper = styled.div`
  padding: var(--bq-spacing-m) 0px;
`

export const TitleH3 = styled.h3``
export const Title = styled.h1`
  margin: 0;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
export const TableContentWrapper = styled.div`
  @media (max-width: 1300px) {
    overflow-x: auto;
  }
  min-height: 200px;
`
export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  white-space: nowrap;
`
export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  padding-top: 10px;
`
export const TableTitleLeft = styled.p`
  width: ${(props) => props.$width};
  text-align: left;
  font-weight: bold;
  padding-left: ${(props) => (props.$leftPadding ? props.$leftPadding : '1rem')};
`
export const InfoRowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 0 10px 0;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  white-space: normal;
  &:hover {
    background-color: #fafafa;
  }
  &:nth-child(odd) {
    background-color: #fafafa;
  }
`
export const InfoRow = styled.div`
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  padding-left: ${(props) => (props.$leftmargin ? props.$leftmargin : '1rem')};
  min-width: ${(props) => (props.$minwidth ? props.$minwidth : '200px')};
  align-items: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const InfoRowActions = styled.div`
  width: ${(props) => (props.$width ? props.$width : '10%')};
  text-align: ${(props) => (props.$align ? props.$align : 'center')};
  min-width: ${(props) => (props.$minwidth ? props.$minwidth : '50px')};
  &:hover {
    overflow: visible;
    white-space: normal;
  }
`

export const InfoRowIcons = styled(InfoRowActions)`
  display: flex;
  min-width: ${(props) => (props.$minwidth ? props.$minwidth : '80px')};
`

export const PaginationWrapper = styled.div`
  margin-left: auto;
  margin-top: 20px;
  text-align: right;
`
export const EditIcon = styled(PeopleEdit)`
  color: ${(props) => (props.disabled ? '#808080' : '#1890ff')};
`
export const DeleteIcon = styled(DeleteDismiss)`
  color: #1890ff;
`
export const Separator = styled.span`
  padding-left: 7px;
  padding-right: 7px;
`
export const Paragraph = styled.p`
  padding: 16px;
`
export const ErrorText = styled.div`
  color: red;
  font-size: 11px;
  margin-left: 3px;
`
export const SectionSeparator = styled.div`
  width: 2px;
  background: #e8e8e8;
  height: 100%;
`
export const Button = styled(btn)`
  margin-left: auto;
  margin-top: -15px;
`

export const TitleBox = styled.div`
  align-self: flex-start;
  font-weight: bold;
`
export const Input = styled.input`
  border-radius: 5px;
  border-width: 1px;
  border-color: #999999;
  width: 100%;
  font-size: 10pt;
`

export const CheckboxColumns = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
`
export const RoleManager = styled.div`
  margin-top: 30px;
`

export const ArrowDown = styled(AD)`
  cursor: pointer;
`
export const ArrowUp = styled(AU)`
  cursor: pointer;
`
export const ArrowSort = styled(AS)`
  cursor: pointer;
`

export const TableActions = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`
